import { Injectable } from '@angular/core';

import { Observable, from } from 'rxjs';
import { tap, catchError, map, retry } from 'rxjs/operators';

import { HttpClient, HttpHeaders }  from "@angular/common/http";

import apiconfig from '../apiconfig';

import { Photo } from './photo'

@Injectable({
  providedIn: 'root'
})
export class FacesService {

  constructor(
        private http: HttpClient
  ) { };

  private photoArray: Photo[] = [];

  private handleError(error:any): any{
    console.log(error)
  }

  public readAllFaces (idToken, username){
    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };

    var input = "{ 'username':'"+username+"' , 'typeOp':'readall' }";

    return this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'face', 'input' : input.replace(/'/g, '"') },httpOptions)
      .toPromise()
      .then((data:any) => {
          console.log(data);
          this.photoArray = data.faces;
          return this.photoArray;
        })
      .catch(err => this.handleError(Error))
  } // end readAllFaces

  public deleteFace(idToken, username, type_key): Observable<any> {

    const httpOptions = {
      headers: new HttpHeaders({
          'Authorization': idToken
      })
    };


    var input = "{ 'username':'"+username+"' , 'type_key':'"+type_key+"' , 'typeOp':'delete' }"

    return from(
      this.http.post(apiconfig.endpoint + "/facegatelambda",{ 'typeOperation' : 'face', 'input' : input.replace(/'/g, '"') },httpOptions),
    ).pipe(
      tap(() => console.log("face deleted"))
    );

  } // end getGetSubscriptionData





}
